import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, AfterViewInit, ElementRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MasterParkingDevice } from '../Models/master-device';
import { DeviceService } from '../ApiServices/device.service';
import { MasterRolePermission } from '../Models/master-role-permission';

@Component({
  selector: 'app-videostreaming',
  templateUrl: './videostreaming.component.html',
  styleUrls: ['./videostreaming.component.css'],
  animations: [
    trigger('widthGrow', [
      state('closed', style({
        width: 0,
        display: 'none'
      })),
      state('open', style({
        width: 720,
        display: 'block'
      })),
      transition('* => *', animate(200))
    ]),
  ]
})
export class VideostreamingComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document, private elementRef: ElementRef, private router: Router, private deviceService: DeviceService) { }

  deviceList: MasterParkingDevice[] = [];
  deviceObj: MasterParkingDevice = new MasterParkingDevice();

  state: string = 'open';

  ngOnInit(): void {
    var token = sessionStorage.getItem('token');
    if (token == null) {
      this.router.navigateByUrl('/');
      return;
    } else {
      if (sessionStorage.getItem("ROLE_PERMISSIONS").toString().indexOf(MasterRolePermission.ViewANPRViewStreaming.rolePermission) < 0) {
        alert("Unauthorised access");
        this.router.navigateByUrl('/index');
        return;
      } else {
        this.LoadDeviceList();
      }
    }
  }
  LoadDeviceList() {
    this.deviceService.getDevices()
      .subscribe((deviceresponse) => {
        this.deviceList = deviceresponse;
      }, (error) => {
        console.log(error);
      }
      );
  }
}
